import React from "react";
import { withTranslation } from "react-i18next";
import { RegistryConfirmationData } from "./RegistryConfirmationData";
import QRCode from "qrcode.react";

import { calcularEdad } from "../../../../../services/utils";
import OxxoPaymentCode from "./OxxoPaymentCode";
import CardPaymentPromissoryNote from "./CardPaymentPromissoryNote";
import DetailOrderConfirmation from "./DetailOrderConfirmation";
import DisclaimerResponsabilitiesHTML from "../DisclaimerResponsabilities/DisclaimerResponsabilitiesHTML";
import jsPDF from "jspdf";
import RegistryConfirmationPdfPreview from "./RegistryConfirmationPdfPreview";

import { Button, Typography } from "@material-ui/core";
import PhotoEditorDefault from "../../PhotoEditorVirtual/PhotoEditorDefault";
import * as fb from "../../../../../firebase/firebasejs";

class RegistryConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tipo: this.props.tipo,
      update: true,
      grupoCompleto: [],
      atletaMostradoKey: this.props.registryParticipantKeyConfirm,
      datosCache: {
        [this.props.registryParticipantKeyConfirm]:
          this.props.registryParticipantDataConfirm,
      },
      esperandoFolio: false,
      folioTimeoutVencido: false,
    };
    this.seleccionarAtletaDelGrupo = this.seleccionarAtletaDelGrupo.bind(this);
  }

  componentDidMount() {
    this.cargarGrupoCompleto();
    this.sincronizarEsperaFolio();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.registryParticipantKeyConfirm !==
      this.props.registryParticipantKeyConfirm
    ) {
      this.setState({
        atletaMostradoKey: this.props.registryParticipantKeyConfirm,
        datosCache: {
          [this.props.registryParticipantKeyConfirm]:
            this.props.registryParticipantDataConfirm,
        },
      });
      this.cargarGrupoCompleto();
    }
    this.sincronizarEsperaFolio();

    // Al pasar de "esperando folio" (contenido corto) a la confirmación
    // completa (mucho más alta, con el preview del PDF), el diálogo de
    // Material-UI puede quedar con el cálculo de su scroll interno
    // desactualizado porque el contenido creció mientras ya estaba abierto
    // — algo que antes no pasaba porque la confirmación completa siempre se
    // montaba de una sola vez. Forzar un evento de resize hace que
    // Material-UI (y el navegador) vuelvan a calcular el alto/scroll
    // disponible.
    if (prevState.esperandoFolio && !this.state.esperandoFolio) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 50);
    }
  }

  componentWillUnmount() {
    this.detenerEsperaFolio();
  }

  // El pago puede quedar en "ok" un momento antes de que el backend termine
  // de asignar el folio/número definitivo (son escrituras separadas). Si se
  // muestra la confirmación en ese instante, el deslinde se puede descargar
  // sin folio. Mientras eso pase, se espera escuchando el registro
  // directamente (sirve sin importar si el flujo que llamó a este
  // componente ya tiene o no un listener en vivo) y se avisa al atleta en
  // vez de mostrar la confirmación a medias.
  sincronizarEsperaFolio() {
    var atletaMostradoKey =
      this.state.atletaMostradoKey || this.props.registryParticipantKeyConfirm;
    var datos =
      this.state.datosCache[atletaMostradoKey] ||
      this.props.registryParticipantDataConfirm;
    if (!datos) return;

    var pagoOk = datos.statusPago && datos.statusPago.status === "ok";
    var tieneFolio =
      datos.numero !== undefined && datos.numero !== null && datos.numero > 0;

    if (!pagoOk || tieneFolio) {
      if (this._folioEsperaKey) this.detenerEsperaFolio();
      if (this.state.esperandoFolio) {
        this.setState({ esperandoFolio: false, folioTimeoutVencido: false });
      }
      return;
    }

    if (this._folioEsperaKey === atletaMostradoKey) return; // ya se está esperando a este atleta

    this.detenerEsperaFolio(); // por si se estaba esperando a otro atleta del grupo
    this._folioEsperaKey = atletaMostradoKey;
    this.setState({ esperandoFolio: true, folioTimeoutVencido: false });

    var eventoIndex = "evento_" + this.props.eventDetail.iDEvento;
    this._folioRef = fb.db.ref(
      "/eventosCompletos/" +
        eventoIndex +
        "/inscritos/listadoInscritos/" +
        atletaMostradoKey +
        "/"
    );
    this._folioListener = (snap) => {
      var actualizado = snap.val();
      if (actualizado && actualizado.numero > 0) {
        this.setState((prevState) => ({
          datosCache: { ...prevState.datosCache, [atletaMostradoKey]: actualizado },
          esperandoFolio: false,
          folioTimeoutVencido: false,
        }));
        this.detenerEsperaFolio();
      }
    };
    this._folioRef.on("value", this._folioListener);

    this._folioTimeout = setTimeout(() => {
      this.setState({ folioTimeoutVencido: true });
    }, 15000);
  }

  detenerEsperaFolio() {
    if (this._folioRef && this._folioListener) {
      this._folioRef.off("value", this._folioListener);
    }
    this._folioRef = null;
    this._folioListener = null;
    this._folioEsperaKey = null;
    if (this._folioTimeout) {
      clearTimeout(this._folioTimeout);
      this._folioTimeout = null;
    }
  }

  cargarGrupoCompleto() {
    var propioKey = this.props.registryParticipantKeyConfirm;
    var propiosDatos = this.props.registryParticipantDataConfirm;
    var propioNombre = propiosDatos.nombres + " " + propiosDatos.apellidos;
    var vinculadosPropios = (propiosDatos.order || []).filter(
      (item) => item && item.inscritoKeyVinculado
    );
    var referenciaPagoPrincipal =
      propiosDatos.statusPago && propiosDatos.statusPago.referenciaPagoPrincipal;

    if (vinculadosPropios.length > 0) {
      // Este registro es el "líder": ya conocemos a todos sin consultar nada más.
      this.setState({
        grupoCompleto: vinculadosPropios.map((item) => ({
          inscritoKey: item.inscritoKeyVinculado,
          nombre: item.name.replace(/^Inscripción de /, ""),
        })),
      });
    } else if (referenciaPagoPrincipal) {
      // Este registro es un atleta adicional: hay que consultar al líder
      // para saber quiénes más forman parte del mismo pago.
      var eventoIndex = "evento_" + this.props.eventDetail.iDEvento;
      fb.db
        .ref(
          "/eventosCompletos/" +
            eventoIndex +
            "/inscritos/listadoInscritos/" +
            referenciaPagoPrincipal +
            "/"
        )
        .once("value")
        .then((snap) => {
          var principal = snap.val();
          var hermanos = (principal.order || []).filter(
            (item) =>
              item &&
              item.inscritoKeyVinculado &&
              item.inscritoKeyVinculado !== propioKey
          );
          var grupo = [
            { inscritoKey: propioKey, nombre: propioNombre },
            {
              inscritoKey: referenciaPagoPrincipal,
              nombre: principal.nombres + " " + principal.apellidos,
            },
          ].concat(
            hermanos.map((item) => ({
              inscritoKey: item.inscritoKeyVinculado,
              nombre: item.name.replace(/^Inscripción de /, ""),
            }))
          );
          this.setState((prevState) => ({
            grupoCompleto: grupo,
            datosCache: {
              ...prevState.datosCache,
              [referenciaPagoPrincipal]: principal,
            },
          }));
        });
    } else {
      this.setState({ grupoCompleto: [] });
    }
  }

  seleccionarAtletaDelGrupo(inscritoKey) {
    if (this.state.datosCache[inscritoKey]) {
      this.setState({ atletaMostradoKey: inscritoKey });
      return;
    }
    var eventoIndex = "evento_" + this.props.eventDetail.iDEvento;
    fb.db
      .ref(
        "/eventosCompletos/" +
          eventoIndex +
          "/inscritos/listadoInscritos/" +
          inscritoKey +
          "/"
      )
      .once("value")
      .then((snap) => {
        this.setState((prevState) => ({
          atletaMostradoKey: inscritoKey,
          datosCache: { ...prevState.datosCache, [inscritoKey]: snap.val() },
        }));
      });
  }

  render() {
    var atletaMostradoKey =
      this.state.atletaMostradoKey || this.props.registryParticipantKeyConfirm;
    var datosMostrados =
      this.state.datosCache[atletaMostradoKey] ||
      this.props.registryParticipantDataConfirm;

    var jsonMail = {};
    jsonMail.inscritoKey = atletaMostradoKey;
    jsonMail.eventoIndex = "evento_" + this.props.eventDetail.iDEvento;

    jsonMail.detalleEvento = this.props.eventDetail;
    jsonMail.datos = datosMostrados;
    jsonMail.modalidades = this.props.eventSubEventsRegistry;
    console.log(this.props.eventSubEventsRegistry);
    jsonMail.inscripcionesConfiguracion = this.props.registryConfiguration;

    var color = "#000000";
    if (jsonMail.detalleEvento.organizador.colorOrganizador != undefined) {
      color = jsonMail.detalleEvento.organizador.colorOrganizador;
    }
    var numero = 0;
    if (jsonMail.datos.numero != undefined) {
      numero = jsonMail.datos.numero;
    }
    var distancia = 0;
    var modIndex = "modalidad_" + jsonMail.datos.modalidad;
    if (jsonMail.datos.modalidad != undefined) {
      distancia = jsonMail.modalidades[modIndex].descripcionModalidad;
    }
    var rama = 0;
    var ramaIndex;
    if (jsonMail.datos.rama != undefined) {
      ramaIndex = "rama_" + jsonMail.datos.rama;
      rama = jsonMail.datos.rama;
    }
    var categoriaJson;
    var categoria;
    var categoriaIndex;
    if (jsonMail.datos.categoria != undefined) {
      categoriaIndex = "categoria_" + jsonMail.datos.categoria;
      categoriaJson =
        jsonMail.modalidades[modIndex].ramaCat[ramaIndex].categorias[
        categoriaIndex
        ];
      categoria = categoriaJson.nombreCategoria;
    }

    // tipo 0 = es que no se muestra la confirmacion todavia
    // tipo 1 = solo confirmacion aplica para pago en efectivo y tarjeta de credito aprobada
    // tipo 2 = registro y ficha de pago
    // tipo 3 = confirmacion de inscripcion y pago recibido en oxxo

    var idioma = "es";

    var jsonTextos = RegistryConfirmationData;


    var fichaDePago;
    if (this.state.tipo == 2) {
      fichaDePago = (
        <OxxoPaymentCode
          jsonMail={jsonMail}
          jsonTextos={jsonTextos}
          idioma={idioma}
          reference={this.props.oxxoReference}
          tipo={this.state.tipo}
        />
      );
    }
    var detalleOrden = (
      <DetailOrderConfirmation
        jsonMail={jsonMail}
        jsonTextos={jsonTextos}
        idioma={idioma}
        reference={this.props.oxxoReference}
        tipo={this.state.tipo}
      />
    );

    var nombresYApellidos = "";
    if (this.state.tipo == 4) {
      nombresYApellidos = this.props.codigoSuscripcion;
    } else {
      nombresYApellidos =
        jsonMail.datos.nombres + " " + jsonMail.datos.apellidos;
    }

    var t = this.props.t;

    if (this.state.tipo == 0) {
      return (
        <Typography color="primary" gutterBottom variant={"h5"} component="h2">
          {t("confirmacion.confirmacionPendiente")}
        </Typography>
      );
    }

    if (this.state.esperandoFolio) {
      return (
        <div className="row center-align">
          <Typography color="primary" gutterBottom variant={"h5"} component="h2">
            {nombresYApellidos}
          </Typography>
          <Typography color="secondary" gutterBottom variant={"subtitle1"} component="h3">
            {t("confirmacion.pagoConfirmado")}
          </Typography>
          {!this.state.folioTimeoutVencido && (
            <Typography color="secondary" gutterBottom variant={"body1"} component="p">
              {t("confirmacion.asignandoFolio")}
            </Typography>
          )}
          {this.state.folioTimeoutVencido && (
            <Typography color="secondary" gutterBottom variant={"body1"} component="p">
              {t("confirmacion.recibirasCorreoFolio")}
            </Typography>
          )}
        </div>
      );
    }

    return (
      <div>
        {this.state.grupoCompleto.length > 0 && (
          <div className="row center-align">
            <Typography
              color="primary"
              gutterBottom
              variant={"h5"}
              component="h2"
            >
              {t("confirmacion.confirmacionGrupo")}
            </Typography>
            <Typography
              color="secondary"
              gutterBottom
              variant={"subtitle2"}
              component="h3"
            >
              {t("confirmacion.verConfirmacionCadaUno")}
            </Typography>
            <div className="col s12">
              <Button
                variant={
                  atletaMostradoKey === this.props.registryParticipantKeyConfirm
                    ? "contained"
                    : "outlined"
                }
                color="primary"
                style={{ margin: "5px" }}
                onClick={() =>
                  this.seleccionarAtletaDelGrupo(
                    this.props.registryParticipantKeyConfirm
                  )
                }
              >
                {this.props.registryParticipantDataConfirm.nombres +
                  " " +
                  this.props.registryParticipantDataConfirm.apellidos}
              </Button>
              {this.state.grupoCompleto.map((atleta) => (
                <Button
                  key={atleta.inscritoKey}
                  variant={
                    atletaMostradoKey === atleta.inscritoKey
                      ? "contained"
                      : "outlined"
                  }
                  color="primary"
                  style={{ margin: "5px" }}
                  onClick={() =>
                    this.seleccionarAtletaDelGrupo(atleta.inscritoKey)
                  }
                >
                  {atleta.nombre}
                </Button>
              ))}
            </div>
            <hr />
          </div>
        )}
        <div className="row center-align">


          <Typography
            color="secondary"
            gutterBottom
            variant={"subtitle2"}
            component="h2"
          >

            {jsonTextos[idioma].preNombre[this.state.tipo]}
          </Typography>
          <Typography
            color="primary"
            gutterBottom
            variant={"h4"}
            component="h2"
          >
            {nombresYApellidos}{" "}
          </Typography>





          <Typography
            color="secondary"
            gutterBottom
            variant={"subtitle2"}
            component="h2"
          >
            {jsonTextos[idioma].postNombre[this.state.tipo]}
          </Typography>
        </div>
        <div className="row center-align">
          <Typography
            color="primary"
            gutterBottom
            variant={"h3"}
            component="h2"
          >
            {jsonMail.detalleEvento.nombreEvento}
          </Typography>
        </div>
        <div className="row center-align">
          <div className="col s6 offset-s3">
            <img
              alt="logo Evento"
              title="logo Evento"
              src={jsonMail.detalleEvento.logoEvento}
              style={{
                border: "none",
                borderRadius: "0px",
                display: "block",
                fontSize: "13px",
                outline: "none",
                textDecoration: "none",
                width: "100%",
              }}
              width={212}
            />
          </div>
        </div>
        <hr />

        <RegistryConfirmationPdfPreview
          title={t("confirmacion.deslindeResponsabilidades")}
          jsonMail={jsonMail}
          qrElementId="qrSeguimiento"
          dorsalElementId="dorsalPreviewCanvas"
          height={500}
          maxWidth={850}
          delay={1500}
          refreshKey={`${jsonMail.inscritoKey}-${this.state.tipo}-${jsonMail.datos.numero}`}
        />

        {jsonMail.inscripcionesConfiguracion.configuracion.dorsal &&
          jsonMail.datos.numero > 0 && (
            <div className="row center-align">
              <div className="col s12">
                <Typography
                  color="primary"
                  gutterBottom
                  variant={"h4"}
                  component="h2"
                >
                  {t("confirmacion.dorsalDigital")}
                </Typography>
              </div>
              <div id="dorsalPreviewCanvas" className="center-align col s12 m12">
                <PhotoEditorDefault
                  size="80%"
                  participant={{
                    raceNumber: jsonMail.datos.numero,
                    athleteName: jsonMail.datos.nombres,
                    athleteLastName: jsonMail.datos.apellidos,
                  }}
                  currentEvent={{
                    distance: 10,
                    raceNumberFontColor:
                      jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                        .raceNumberFontColor,
                    raceNumberWhiteBack:
                      jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                        .raceNumberWhiteBack,
                    raceNumberVertical: jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                      .raceNumberVertical || 1

                  }}
                  urlPhoto={
                    jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                      .raceNumberImage
                  }
                  type={"raceNumber"}
                />
              </div>
            </div>
          )}


        <hr />
        <div className="row center-align">
          <Typography
            color="primary"
            gutterBottom
            variant={"h5"}
            component="h2"
          >
            {jsonTextos[idioma].LinkYQRSeguimiento}
          </Typography>

          <div className="col s12 m12">
            <QRCode
              id="qrSeguimiento"
              value={
                jsonMail.inscripcionesConfiguracion.configuracion
                  .rutaDetalleInscrito +
                "?event=" +
                jsonMail.eventoIndex +
                "&registry=" +
                jsonMail.inscritoKey +
                "&download=true"
              }
            />
          </div>
          <div className="col s12 m12">
            <Typography
              color="primary"
              gutterBottom
              variant={"h5"}
              component="h2"
            >
              <a
                target="_blank"
                href={`${jsonMail.inscripcionesConfiguracion.configuracion.rutaDetalleInscrito}?event=${jsonMail.eventoIndex}&registry=${jsonMail.inscritoKey}&download=true`}
              >
                {jsonMail.inscripcionesConfiguracion.configuracion
                  .rutaDetalleInscrito +
                  "?event=" +
                  jsonMail.eventoIndex +
                  "&registry=" +
                  jsonMail.inscritoKey +
                  "&download=true"}
              </a>
            </Typography>
          </div>
        </div>
        <hr />
        <div className="row center-align">
          <div className="col s12">
            <Typography
              color="primary"
              gutterBottom
              variant={"h5"}
              component="h2"
            >
              {jsonTextos[idioma].tituloDatos}{" "}
            </Typography>
          </div>
          <div className="col s3 center-align">
            <Typography
              color="primary"
              gutterBottom
              variant={"subtitle1"}
              component="h2"
            >
              {jsonTextos[idioma].Numero}
              <br />
              <b className="center-align">{numero}</b>
            </Typography>
          </div>
          <div className="col s3  center-align">
            <Typography
              color="primary"
              gutterBottom
              variant={"subtitle1"}
              component="h2"
            >
              {jsonTextos[idioma].Distancia}
              <br />
              <b className="center-align">{distancia}</b>
            </Typography>
          </div>
          <div className="col s3  center-align">
            <Typography
              color="primary"
              gutterBottom
              variant={"subtitle1"}
              component="h2"
            >
              {jsonTextos[idioma].Rama}
              <br />
              <b className="center-align">{rama}</b>
            </Typography>
          </div>
          <div className="col s3 center-align">
            <Typography
              color="primary"
              gutterBottom
              variant={"subtitle1"}
              component="h2"
            >
              {jsonTextos[idioma].Categoria}
              <br />
              <b>{categoria}</b>
            </Typography>
          </div>
        </div>
        <hr />

        {detalleOrden}
        <hr />
        {fichaDePago}

        <footer />
      </div>
    );
  }
}

export default withTranslation("inscripcion")(RegistryConfirmation);
